// extracted by mini-css-extract-plugin
export default {"main":"DdGVWTxycItMEAYiShYm","scale":"s6ld3uKmPBmFVTaNrGho","innerHTMLContainer":"Gyp2tu7KBps7OIiUzN0B","common_bganimation":"klu4BWfl4jCiF2Z2qonu"};